import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { Box } from '@mui/material';
import OrgDirectoryHeader from '../components/OrgDirectoryHeader';
import OverviewTable from '../components/OverviewTable';
import OverviewListFilter from '../components/OverviewListFilter';
import useOverviewFilters from '../components/OverviewFilterHelper';

const OrgDirectoryListPage = () => {
  useDocumentTitle('Org Directory');

  const filters = [
    {
      type: 'search',
      options: [
        {
          key: 'org_email',
          placeholder: 'Account Email',
        },
        {
          key: 'tin',
          placeholder: 'TIN',
        },
        {
          key: 'email',
          placeholder: 'Emaratax Email',
        },
      ],
    },
  ];

  const { selectedFilter, searchTerm, handleFilterChange, handleSearchChange } = useOverviewFilters();

  return (
    <Box sx={{ p: 1, ml: 20, mr: 20 }}>
      <OrgDirectoryHeader />
      <OverviewListFilter
        filters={filters}
        selectedFilter={selectedFilter}
        onFilterChange={handleFilterChange}
        searchTerm={searchTerm}
        onSearchChange={handleSearchChange}
      />
      <OverviewTable selectedFilter={selectedFilter} searchTerm={searchTerm} />
    </Box>
  );
};

export default OrgDirectoryListPage;
